// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_SalvarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/traducoes/salvar — one key, one language.
 *
 * `texto` may NOT be blank. Upstream updates with GORM's `Updates(struct)`,
 * which skips zero values, so an empty string is a silent no-op: the old
 * translation survives and the endpoint still answers success. Clearing a
 * translation is simply not something translations-service can do, and the
 * controller refuses it (422) rather than pretending it worked.
 */
import { registerContract } from './validate'

export interface Traducoes_SalvarInput {
pagina?: string
chave?: string
idioma?: string
texto?: string
}

registerContract('Traducoes_SalvarInput', {
  pagina: { type: 'string',  required: false },
  chave:  { type: 'string',  required: false },
  idioma: { type: 'string',  required: false },
  texto:  { type: 'string',  required: false },
})
